import { useEffect, useState } from "react";

export const useInViewCount = (
  targetElement: Element | null | undefined,
  selector: string
) => {
  const [inViewCount, setInViewCount] = useState<number | null>(null);

  useEffect(() => {
    if (!targetElement) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const intersectingEntries = entries.filter(
          (entry) => entry.isIntersecting
        );
        setInViewCount(intersectingEntries.length);

        intersectingEntries.forEach((entry) =>
          observer.unobserve(entry.target)
        );
      },
      { threshold: [0], root: targetElement }
    );
    const targets = targetElement.querySelectorAll(selector);

    //set inViewCount to 0 if there are no targets with that selector
    if (targets.length) {
      targets.forEach((el) => observer.observe(el));
    } else {
      setInViewCount(0);
    }

    return () => observer.disconnect();
  }, [targetElement, selector]);

  return inViewCount;
};
